import { FormAtom, SpacerAtom } from "../../atoms";
import styles from "./styles.module.scss";

interface Props {
  children: any;
  rightButton?: JSX.Element;
  leftButton?: JSX.Element;
}

export function FormMolecule(props: Readonly<Props>) {
  return (
    <FormAtom additionalClassname={styles.form}>
      {props.children}
      {(props.rightButton || props.leftButton) && (
        <div className={styles.form__container}>
          <div className={styles.form__container__buttons}>
            {props.leftButton}
            <SpacerAtom space={4} type="horizontal" />
            {props.rightButton}
          </div>
        </div>
      )}
    </FormAtom>
  );
}
